/**
 * Internal dependencies
 */
import { WMUSelect } from "@wakemeup/select";
import { WMUPassword } from "@wakemeup/password";
import { WMUNumber } from "@wakemeup/number";

/**
 * 
 */
class WMUFields {

	/**
	 * 
	 */
	static fieldElementList = [];

	/**
	 * 
	 */
	static init()
	{
		document.addEventListener( 'DOMContentLoaded', WMUFields.onDOMContentLoaded );
	}

	/**
	 * 
	 */
	static update( contextElement )
	{
		contextElement.querySelectorAll( '.wmu-field' ).forEach( ( element ) => WMUFields.activate( element ) );

		/**
		 * @hack Gestion de l'autofill de webkit qui pose soucis avec la classe empty
		 */
		setTimeout( () =>
		{
			contextElement.querySelectorAll( '*:-webkit-autofill' ).forEach( (inputElement) =>
			{
				const wmuFieldElement = inputElement.closest( '.wmu-field' );
				if ( wmuFieldElement )
				{
					wmuFieldElement.classList.remove( 'empty' );
				}
			} );
		}, 100 );
	}

	/**
	 * 
	 */
	static activate( element )
	{
		if ( WMUFields.fieldElementList.indexOf( element ) === -1 )
		{
			// console.log( 'wmuFields.activate', element, element.value );

			/**
			 * Global behaviors
			 * 
			 * @note Radio base is activated within activateRadio method
			 */
			element.querySelectorAll( 'input:not([type="radio"]), textarea, select' ).forEach( ( realElement ) =>
			{
				WMUFields.activateBase( realElement );
			} );

			/**
			 * Specific behaviors
			 */
			if ( true === element.classList.contains( 'wmu-field-checkbox' ) )
			{
				WMUFields.activateCheckbox( element );
			}
			else if ( true === element.classList.contains( 'wmu-field-number' ) )
			{
				WMUFields.activateNumber( element );
			}
			else if ( true === element.classList.contains( 'wmu-field-password' ) )
			{
				WMUFields.activatePassword( element );
			}
			else if ( true === element.classList.contains( 'wmu-field-radio' ) )
			{
				WMUFields.activateRadio( element );
			}
			else if ( true === element.classList.contains( 'wmu-field-select' ) )
			{
				WMUFields.activateSelect( element );
			}

			WMUFields.fieldElementList.push( element );
		}
	}

	/**
	 * 
	 * @param {*} element 
	 */
	static activateBase( element )
	{
		element.addEventListener( 'focusin', WMUFields.onFieldFocusIn );
		element.addEventListener( 'focusout', WMUFields.onFieldFocusOut );
		element.addEventListener( 'change', WMUFields.onFieldChange );
		element.addEventListener( 'input', this.onFieldChange );
		
		element.dispatchEvent( new CustomEvent( 'change', { bubbles: true } ) );
	}

	/**
	 * 
	 * @param {*} element 
	 */
	static activateCheckbox( element )
	{
		const inputElement = element.querySelector( 'input' );

		if ( inputElement )
		{
			const dummyElement = document.createElement( 'div' );
			dummyElement.classList.add( 'wmu-field-checkbox-dummy' );
			dummyElement.inputElement = inputElement;

			inputElement.after( dummyElement );

			dummyElement.addEventListener( 'click', ( event ) =>
			{
				inputElement.checked = ! inputElement.checked;
				inputElement.dispatchEvent( new CustomEvent( 'change', { bubbles: true } ) );
			} );
		}
	}

	/**
	 * 
	 * @param {*} element 
	 */
	static activateNumber( element )
	{
		const inputElement = element.querySelector( 'input[type="number"]' );

		if ( inputElement )
		{
			element.wmuNumber = new WMUNumber( inputElement );
		}
	}

	/**
	 * 
	 * @param {*} element 
	 */
	static activatePassword( element )
	{
		const inputElement = element.querySelector( 'input[type="password"]' );

		if ( inputElement )
		{
			element.wmuPassword = new WMUPassword( inputElement );
		}
	}

	/**
	 * 
	 * @param {*} element 
	 */
	static activateRadio( element )
	{
		const inputName = element.getAttribute( 'data-input-name' );

		element.querySelectorAll( `input[type="radio"][name="${inputName}"]` ).forEach( ( inputElement ) =>
		{
			WMUFields.activateBase( inputElement );

			const dummyElement = document.createElement( 'div' );
			dummyElement.classList.add( 'wmu-field-radio-dummy' );
			dummyElement.inputElement = inputElement;

			inputElement.after( dummyElement );

			dummyElement.addEventListener( 'click', ( event ) =>
			{
				inputElement.checked = true;
				inputElement.dispatchEvent( new CustomEvent( 'change', { bubbles: true } ) );
			} );
		} );
	}

	/**
	 * 
	 * @param {*} element 
	 */
	static activateSelect( element )
	{
		const selectElement = element.querySelector( 'select' );

		if ( selectElement )
		{
			element.wmuSelect = new WMUSelect( selectElement );
			element.wmuSelect.addEventListener( 'change', ( event ) =>
			{
				const isEmpty = ! ( event.detail && event.detail.selection && event.detail.selection.length );

				if ( true === isEmpty )
				{
					element.closest( '.wmu-field-select' ).classList.add( 'empty' );
				}
				else
				{
					element.closest( '.wmu-field-select' ).classList.remove( 'empty' );
				}
			} );
		}
	}

	/**
	 * 
	 * @param {*} event 
	 */
	static onDOMContentLoaded( event )
	{
		WMUFields.update( document );
	}

	/**
	 * 
	 */
	static onFieldFocusIn( event )
	{
		this.closest( '.wmu-field' ).classList.add( 'focus' );
	}

	/**
	 * 
	 */
	static onFieldFocusOut( event )
	{
		this.closest( '.wmu-field' ).classList.remove( 'focus' );
	}

	/**
	 * 
	 */
	static onFieldChange( event )
	{
		const wmuFieldElement = this.closest( '.wmu-field' );

		switch ( this.getAttribute( 'type' ) )
		{
			default:
				if ( this.value )
				{
					wmuFieldElement.classList.remove( 'empty' );
				}
				else
				{
					wmuFieldElement.classList.add( 'empty' );
				}
			break;

			case 'checkbox':
				if ( this.checked )
				{
					wmuFieldElement.classList.remove( 'empty' );
					wmuFieldElement.classList.add( 'checked' );
				}
				else
				{
					wmuFieldElement.classList.add( 'empty' );
					wmuFieldElement.classList.remove( 'checked' );
				}
			break;

			case 'radio':
				const inputName = wmuFieldElement.getAttribute( 'data-input-name' );

				wmuFieldElement.querySelectorAll( `input[type="radio"][name="${inputName}"]` ).forEach( ( inputElement ) =>
				{
					if ( true === inputElement.checked )
					{
						inputElement.closest( '.wmu-input-radio-option' ).classList.add( 'checked' );
					}
					else
					{
						inputElement.closest( '.wmu-input-radio-option' ).classList.remove( 'checked' );
					}
				} );
			break;
		}
	}

}

export default WMUFields;